<template>
  <div class="">
    <div v-if="!vessels.length" class="flex w-full h-full flex-col items-center justify-center">
      <svg width="152" height="100" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.176 77.516 3.469 64.99V53.915h7.516m117.847 24.738 19.704-24.739h-42.709l-4.772 4.288H37.23m-26.245-4.288h15.15l4.772 4.288h6.323m-26.245-4.288v-6.383m0 0H37.23m-26.245 0H8.479v-3.143h6.204v-6.265m22.547 9.408h2.386v-3.143H37.23v-6.265m0 9.408v10.67m0-20.078H14.683m22.547 0h2.386V34.98H37.23v-5.955h-4.294m-18.253 9.098h-2.386V34.98h10.856m9.782-5.955-5.964 5.955h-3.818m9.782-5.955v-5.55M23.153 34.98l1.945-11.504m.614-3.692.634-3.977h6.59v3.977m-7.224 0h7.223m-7.223 0-.614 3.692m7.837-3.692v3.692m0 0h-7.837" stroke="#DEE3EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M78.856 14.862c0-2.243-1.492-2.33-2.345-2.535-.19-.76-.832-2.618-3.22-2.766-2.386-.148-3.6 1.403-3.954 2.245-1.35 0-4.76.467-4.76 3.056 0 2.072 2.179 2.63 3.268 2.651h8.027c.995-.103 2.984-.777 2.984-2.65ZM105.699 29.652c0-5.127 3.163-5.325 4.97-5.795.401-1.738 1.765-5.985 6.825-6.323 5.06-.338 7.632 3.208 8.385 5.134 2.862 0 10.09 1.065 10.09 6.984 0 4.735-4.618 6.013-6.927 6.06h-17.018c-2.108-.235-6.325-1.776-6.325-6.06Z" stroke="#DEE3EA" stroke-width="2"/><path d="M14.316 79.506c1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844m12.545-2.844c.835 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.835 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.835 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844M43.629 81.781c.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.835 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844m12.545-2.844c.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.395 2.844 4.181 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.394 2.844 4.181 2.844M6.2 84.625c1.786 0 3.346-1.144 4.18-2.844.835 1.7 2.395 2.844 4.182 2.844 1.787 0 3.347-1.144 4.182-2.844.834 1.7 2.394 2.844 4.181 2.844s3.347-1.144 4.182-2.844c.834 1.7 2.394 2.844 4.181 2.844" stroke="#DEE3EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="61" r="2" stroke="#DEE3EA" stroke-width="2"/><circle cx="22" cy="61" r="2" stroke="#DEE3EA" stroke-width="2"/></svg>
      <h1 class="m-t-4 m-b-3 fz18 fw500">The vessel list is empty</h1>
      <p class="fz14 text-dark-gray text-align-center">Add a vessels on the <br>Vessels screen</p>
    </div>

    <div v-else class="p-t-7">
      <div class="calc_compare__main_row">
        <div class="fw500">Sort best to worst by:</div>
        <button 
          v-for="fuel in fuelTypes" :key="fuel"
          class="p-x-1 text-align-center fz0 hover:text-dark-gray" 
          :class="{
            'text-gray-light': activeFuel != fuel,
            'text-blue-dark': activeFuel == fuel
          }"
          @click="activeFuel = fuel"
          type="button"
        >
          <span class="capitalize fw500 fz16">{{fuel}}</span>
          <span class="inline-block w-full h-0.5 m-t-1 fz0 bg-current rounded"></span>
        </button>
      </div>

      <div class="border border-dark-gray rounded-lg m-t-2 overflow-hidden">
        <div class="calc_compare__main_row bg-gray-dark fz13 text-gray-text">
          <div class="calc_compare__vessel_row">
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'Vessel name'">Vessel name</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'DWT'">DWT</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'Built'">Built</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'Hire'">Hire</div>
          </div>
          <div 
            v-for="fuel in fuelTypes" :key="fuel"
            class="calc_compare__fuel_row border-l border-dark-gray"
          >
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'Result, $'">Result, $</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'Hire BEP, $'">Hire BEP, $</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'Freight BEP, $'">Freight BEP, $</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="'Voyage Days'">Voyage Days</div>
          </div>
        </div>

        <div 
          class="calc_compare__main_row border-t border-gray-text fz13 text-dark-gray"
          v-for="(vessel, index) in sortingVessels" :key="vessel.id"
          :class="{
            'bg-gray-lightest': index % 2,
            'bg-white': !(index % 2),
          }"
        >
          <div class="calc_compare__vessel_row">
            <div class="p-y-1 p-l-1 p-r-1 fw500 text-dark" v-tooltip="vessel.name">{{vessel.name}}</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="vessel.dwt ? `${vessel.dwt}` : null">{{vessel.dwt}}</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="vessel.year ? `${vessel.year}` : null">{{vessel.year}}</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="$options.filters.formatNumber(vessel.hire)">{{vessel.hire | formatNumber}}</div>
          </div>
          <div 
            v-for="fuel in fuelTypes" :key="fuel"
            class="calc_compare__fuel_row border-l border-dark-gray"
          >
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="vessel[fuel+'_result'] ? $options.filters.formatNumberZeroEmpty(vessel[fuel+'_result']) : null">{{vessel[fuel+'_result'] | formatNumberZeroEmpty}}</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="vessel[fuel+'_hire'] ? $options.filters.formatNumberZeroEmpty(vessel[fuel+'_hire']) : null">{{vessel[fuel+'_hire'] | formatNumberZeroEmpty}}</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="vessel[fuel+'_freight'] ? $options.filters.formatNumberZeroEmpty(vessel[fuel+'_freight']) : null">{{vessel[fuel+'_freight'] | formatNumberZeroEmpty}}</div>
            <div class="p-y-1 p-l-1 p-r-1" v-tooltip="vessel[fuel+'_voyage_days'] ? $options.filters.formatNumberZeroEmpty(vessel[fuel+'_voyage_days']) : null">{{vessel[fuel+'_voyage_days'] | formatNumberZeroEmpty}}</div>
          </div>
        </div>
      </div>
      <div class="p-t-4"></div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'

export default {
  name: 'tabCompare',
  data() {
    return {
      vessels: [],
      fuelTypes: ['full', 'eco', 'optimal', 'slow'],
      activeFuel: 'full'
    }
  },
  computed: {
    sortingVessels() {
      let sorting = [...this.vessels]
      return sorting.sort((a,b) => {
        return a[this.activeFuel+'_result'] < b[this.activeFuel+'_result'] ? 1 : -1
      })
    },
  },
  watch: {
    activeFuel: function () {
      this.setActiveFuelType(this.activeFuel)
    },
  },
  methods: {
    ...mapActions(['axiosGetCalcVessel']),
    ...mapMutations(['setActiveFuelType', 'showLoad', 'hideLoad']),
  },
  mounted() {
    this.setActiveFuelType(this.activeFuel)
  },
  async beforeMount() {
    this.showLoad()
    this.vessels = await this.axiosGetCalcVessel(this.$route.params.id)
    this.hideLoad()
  }
}
</script>

<style lang="scss">
.calc_compare__main_row{
  display: grid;
  grid-template-columns: 18.42% repeat(4, 20.4%);
}
.calc_compare__vessel_row{
  display: grid;
  grid-template-columns: 37.58% 20.47% 16.78% 25.17%;
  >div{
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:not(:last-child){
      border-right: 1px solid var(--color-gray-light);
    }
  }
}
.calc_compare__fuel_row{
  display: grid;
  grid-template-columns: 24.85% 22.42% 27.27% 25.45%;
  >div{
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:not(:last-child){
      border-right: 1px solid var(--color-gray-light);
    }
  }
}
</style>